import React, { Component } from "react";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import { withRouter } from "react-router";
import { Accordion } from "react-bootstrap";
import parse from "html-react-parser";
import { Link } from "react-router-dom";
import Breadcrumb from "../Breadcrumb";
import CreateGetFaqsAction from "../../store/actionCreators/CreateGetFaqsAction";

class PublicFAQPage extends Component {
    constructor() {
        super();

        this.doLogin = this.doLogin.bind(this);

        this.state = {
            collapsed: true,
            userIsAuthenticated: false
        };
    }

    async componentDidMount() {
        try {
            this.props.getFaqs();

            // Call server to see if user is authenticated
            const res = await fetch("/Account/whoami", { credentials: "include" });
            if (res.ok) {
                const data = await res.json();
                this.setState({ userIsAuthenticated: data.isAuthenticated });
            } else {
                this.setState({ userIsAuthenticated: false });
            }
        } catch (err) {
            console.error("Error checking user authentication:", err);
            this.setState({ userIsAuthenticated: false });
        }
    }

     

    doLogin() {
        const { history } = this.props;

        // Call to check if already logged in
        fetch("/Account/whoami", { credentials: "include" })
            .then(res => res.json())
            .then(user => {
                if (user.username) {
                    // Already logged in, go to dashboard
                    history.push("/dashboard");
                } else {
                    // Not logged in, redirect to MVC login page
                    window.location.href = "/Account/Login";
                }
            })
            .catch(err => {
                console.error("Error checking login status:", err);
                // fallback to login page
                window.location.href = "/Account/Login";
            });
    }


    render() {

        const t = this.props.t;

        return (
            <React.Fragment>
                <Breadcrumb
                    role=""
                    homeLink={t("Common.ButtonText.Home")}
                    pageName={t("PublicFAQPage.FAQPageHeading")} />

                <div className="row">
                    <div className="col-md-12">
                        <div className="h5 text-center">{t("PublicFAQPage.FAQPageHeading")}</div>
                    </div>
                </div>
                <hr className="srl-hr" />

                <div className="mb-5 ">
                    {
                        this.props.faqs.length > 0 &&
                        <Accordion flush>
                            {
                                this.props.faqs.map((faq,index) => {
                                    return (
                                        <Accordion.Item key={index} eventKey={faq.id}>
                                            <Accordion.Header><strong>{faq.name}</strong></Accordion.Header>
                                            <Accordion.Body>
                                                {parse(faq.description)}
                                            </Accordion.Body>
                                        </Accordion.Item>
                                        );
                                })
                            }
                        </Accordion>
                    }
                </div>
                <p>&nbsp;</p>
            </React.Fragment>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        faqs: state.faqs || []
    };
};

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        getFaqs: () => {
            dispatch(CreateGetFaqsAction());
        }
    };
};

const languageAwareComponent = withTranslation()(withRouter(PublicFAQPage));

export default connect(mapStateToProps, mapDispatchToProps)(languageAwareComponent);